// extracted by mini-css-extract-plugin
export default {"productGallery":"kO-z","inQuickShop":"lO-z"};